import React from 'react';

export type SpacerProps = {
    size?: string | number;
};

export const Spacer: React.FC<SpacerProps> = ({ size = '1rem' }) => {
    return <div style={{ height: size }} />;
};
